/** App이 수신해 사이드바 채팅 메뉴 미읽음 배지를 재조회 */
export const CHAT_UNREAD_REFRESH_EVENT = 'gopai:chat-unread-refresh';

export function requestChatUnreadCountRefresh() {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(CHAT_UNREAD_REFRESH_EVENT));
}
